import Icon from "@ant-design/icons";

const Svg = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.99557 7.12891V10.4167M9.99634 12.8735H10.0039M10 3C13.8655 3 17 6.13373 17 10C17 13.8655 13.8655 17 10 17C6.13373 17 3 13.8655 3 10C3 6.13373 6.13373 3 10 3Z" stroke="#1890FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
export const MyIcon = (props: any) => <Icon component={Svg} {...props} />;